import { render, staticRenderFns } from "./categoryManagerOrg.vue?vue&type=template&id=2cd3d3d0&scoped=true&"
import script from "./categoryManagerOrg.vue?vue&type=script&lang=js&"
export * from "./categoryManagerOrg.vue?vue&type=script&lang=js&"
import style0 from "./categoryManagerOrg.vue?vue&type=style&index=0&id=2cd3d3d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd3d3d0",
  null
  
)

export default component.exports